import styled from 'styled-components';

export const ScrollLoaderWrapper = styled('div')`
  width: 100%;
`;

interface ScrollPaneProps {
  paddingTop?: number;
  paddingBottom?: number;
}

export const ScrollPane = styled('div')<ScrollPaneProps>`
  padding-top: ${(props) => (props.paddingTop ? props.paddingTop : 0)}px;
  padding-bottom: ${(props) =>
    props.paddingBottom ? props.paddingBottom : 0}px;
`;

export const Loader = styled('div')`
  padding: 32px 0 56px;
`;

export const IntersectionBox = styled('div')`
  width: 0;
  height: 16px;
  margin-bottom: -16px;
`;
